import { Colors, Lightning, Router, Storage } from '@lightningjs/sdk';
import lng from '@lightningjs/core';

export default class EpisodesComponent extends Lightning.Component {
  static _template() {
    return {
      h: 50,
      collision: true,
      EpisodeImage: {
        w: 430,
        h: 220,
        texture: {
          type: Lightning.textures.ImageTexture,
          src: this._src,
          resizeMode: { type: 'cover', w: 430, h: 220 },
        },
        shader: {
          type: lng.shaders.RoundedRectangle,
          radius: 15,
        },
        ResumeProgress: {
          Progress: {},
        },
      },

      EpisodeInfo: {
        x: 1325 - 845,
        w: 505,
        h: 250,
        EpisodeTitle: {},
        EpisodeDuration: {},
        EpisodeDescription: {},
      },
      SeasonBorder: {},
    };
  }

  set movieInfo(val) {
    return (this._movieInfo = val);
  }

  set src(val) {
    return (this._src = val);
  }

  set episodes(val) {
    return (this._episodes = val);
  }

  set index(val) {
    this._index = val;
  }

  get movieInfo() {
    return this._movieInfo;
  }

  get _TextBorder() {
    return this.tag('TextBorder');
  }

  get _EpisodeTitle() {
    return this.tag('EpisodeTitle');
  }

  get _EpisodeImage() {
    return this.tag('EpisodeImage');
  }

  get _EpisodeDuration() {
    return this.tag('EpisodeDuration');
  }

  get _EpisodeDescription() {
    return this.tag('EpisodeDescription');
  }

  get _SeasonBorder() {
    return this.tag('SeasonBorder');
  }

  getFocus() {
    return this._EpisodeImage;
  }

  _focus() {
    super._focus();
    this._SeasonBorder.patch({
      x: -5,
      y: -5,
      texture: lng.Tools.getRoundRect(434, 224, 15, 4, Colors('#02AC25').get(), false),
    });
    let percentageCompleted =
      (this._episodes.resume_time / this._convertToSeconds(this._episodes.duration)) * 100;
    if (this._episodes.resume_time !== '0' && this._episodes.resume_time !== '') {
      this.tag('ResumeProgress').patch({
        w: 430,
        h: 7,
        y: 213,
        rect: true,
        zIndex: 1,
        color: Colors('#D6D6D6').get(),
      });
      this.tag('Progress').patch({
        w: (percentageCompleted / 100) * 430,
        h: 7,
        rect: true,
        color: Colors('#FB3A67').get(),
        zIndex: 10,
      });
    }
  }

  _unfocus() {
    super._unfocus();
    this._SeasonBorder.patch({
      texture: null,
    });
    let percentageCompleted =
      (this._episodes.resume_time / this._convertToSeconds(this._episodes.duration)) * 100;
    if (this._episodes.resume_time !== '0' && this._episodes.resume_time !== '') {
      this.tag('EpisodeImage.ResumeProgress').patch({
        x: 0,
        w: 430,
        h: 7,
        y: 213,
        rect: true,
        zIndex: 1,
        color: Colors('#D6D6D6').get(),
      });
      this.tag('EpisodeImage.ResumeProgress.Progress').patch({
        w: (percentageCompleted / 100) * 430,
        h: 7,
        rect: true,
        color: Colors('#FB3A67').get(),
        zIndex: 10,
      });
    }
  }

  _convertToSeconds(duration) {
    let hours;
    let minutes;
    let seconds;
    const timeParts = duration.split(':');
    if (timeParts.length === 3) {
      hours = parseInt(timeParts[0]);
      minutes = parseInt(timeParts[1]);
      seconds = parseInt(timeParts[2]);
    }
    if (timeParts.length === 2) {
      hours = parseInt('00');
      minutes = parseInt(timeParts[0]);
      seconds = parseInt(timeParts[1]);
    }
    if (isNaN(hours) || isNaN(minutes) || isNaN(seconds)) {
      throw new Error('Invalid duration format. Hours, minutes, and seconds must be numbers.');
    }
    return hours * 3600 + minutes * 60 + seconds;
  }

  _handleHover() {
    this.fireAncestors('$setState', 'Column');
    this.fireAncestors('$setIndex', this._index);
    this._focus();
  }

  _handleUnhover() {
    this._unfocus();
  }

  _handleClick() {
    this._handleEnter();
  }

  _firstEnable() {
    this._EpisodeTitle.patch({
      text: {
        text: this._episodes.name,
        fontFace: 'OpenSans-SemiBold',
        fontSize: 28,
        lineHeight: 33,
        textColor: Colors('#ffffff').get(),
        wordWrapWidth: 550,
        maxLines: 2,
      },
    });

    let percentageCompleted =
      (this._episodes.resume_time / this._convertToSeconds(this._episodes.duration)) * 100;
    if (this._episodes.resume_time !== '0' && this._episodes.resume_time !== '') {
      this.tag('ResumeProgress').patch({
        w: 430,
        h: 7,
        y: 213,
        rect: true,
        zIndex: 1,
        color: Colors('#D6D6D6').get(),
      });
      this.tag('Progress').patch({
        w: (percentageCompleted / 100) * 430,
        h: 7,
        rect: true,
        color: Colors('#FB3A67').get(),
        zIndex: 10,
      });
    }
    this._EpisodeDuration.patch({
      y: 65,
      text: {
        text: this._episodes.duration,
        fontFace: 'OpenSans-Regular',
        fontSize: 27.5,
        lineHeight: 33,
        textColor: Colors('#ffffff').get(),
        wordWrapWidth: 400,
      },
    });
    this._EpisodeDescription.patch({
      y: 100,
      text: {
        text: this._episodes.description,
        fontFace: 'OpenSans-Regular',
        fontSize: 21,
        lineHeight: 30,
        textColor: Colors('#fafafa').get(),
        wordWrapWidth: 550,
        maxLines: 4,
      },
    });
    this._EpisodeImage.patch({
      src: this._src,
    });

    this.fireAncestors('$changeSeriesInfo', {
      title: this._movieInfo.name,
      description: this._movieInfo.description,
      category: this._movieInfo.data[0].movies[0].tags,
      duration: this._movieInfo.data[0].movies[0].duration,
      rating:
        this._movieInfo.data[0].movies[0].imdb.rating === null
          ? '−'
          : this._movieInfo.data[0].movies[0].imdb.rating.avg,
      votes:
        this._movieInfo.data[0].movies[0].imdb.rating === null
          ? '−'
          : this._movieInfo.data[0].movies[0].imdb.rating.num_votes,
      contentRating: this._movieInfo.data[0].movies[0].content_rating,
      seasonNumber: this._movieInfo.data[0].movies[0].season_number,
    });
  }

  _handleEnter() {
    let video = Storage.get('video');
    Storage.set('video', { ...video, watchList: video.watchList });
    Router.navigate(`movie/${this._episodes.id}`);
  }
}
